export const GET_MAP_VIEW_SUCCESS ='GET_MAP_VIEW_SUCCESS';
export const GET_MAP_VIEW_FAIL = 'GET_MAP_VIEW_FAIL';